/*
Copyright 2025 New Vector Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

export const isLivekitTransportConfig = object => object.type === "livekit" && "livekit_service_url" in object;
export const isLivekitTransport = object => isLivekitTransportConfig(object) && "livekit_alias" in object;

/**
 * @deprecated this is just needed for the old focus active / focus fields of a call membership.
 * Not needed for new implementations.
 */

/**
 * @deprecated see LivekitFocusSelection
 */
export const isLivekitFocusSelection = object => object.type === "livekit" && "focus_selection" in object;
//# sourceMappingURL=LivekitTransport.js.map